import { Command } from "./command.js";
/**
 * @see https://redis.io/commands/scan
 */
export class ScanCommand extends Command {
    constructor([cursor, opts], cmdOpts) {
        const command = ["scan", cursor];
        if (opts?.match) {
            command.push("match", opts.match);
        }
        if (typeof opts?.count === "number") {
            command.push("count", opts.count);
        }
        super(command, cmdOpts);
    }
}
